import React, { Fragment } from 'react';
import cl from 'classnames';
import { Tabs } from 'antd';
import { Swiper } from 'antd-mobile';
import { HexToRGB } from '@/utils/utils';
import { openConfiguredLink } from '@/utils/navigation';
import { Clickable } from '@/components';
import styles from './index.less';

function QuickAccess({
  visible,
  menuStyle,
  sheet1,
  sheet2,
  sheet1Pictures = [],
  sheet2Pictures = [],
  activeTabKey,
  tabFontSize,
  tabFontColor,
  tabFontColorOpacity,
  isTabFontBold,
  isTabFontItalic,
  iconFontColor,
  iconFontColorOpacity,
  topMargin,
  hasBackground,
  bgImg,
  horizontalOutterMargin,
  horizontalInnerPadding,
}) {
  const tab1ColorStyles = {
    fontWeight: isTabFontBold === 'Y' ? 'bold' : 'normal',
    // fontFamily: isTabFontBold === 'Y' ? 'NunitoSans-Bold' : 'NunitoSans-Regular',
    fontFamily: 'Roboto',
    fontStyle: isTabFontItalic === 'Y' ? 'italic' : 'normal',
    fontSize: `${tabFontSize}px`,
    color: activeTabKey === 'SHEET1' ? HexToRGB(tabFontColor, tabFontColorOpacity) : '#2d3040',
  };

  const tab2ColorStyles = {
    fontWeight: isTabFontBold === 'Y' ? 'bold' : 'normal',
    // fontFamily: isTabFontBold === 'Y' ? 'NunitoSans-Bold' : 'NunitoSans-Regular',
    fontFamily: 'Roboto',
    fontStyle: isTabFontItalic === 'Y' ? 'italic' : 'normal',
    fontSize: `${tabFontSize}px`,
    color: activeTabKey === 'SHEET2' ? HexToRGB(tabFontColor, tabFontColorOpacity) : '#2d3040',
  };

  const nameStyle = {
    color: HexToRGB(iconFontColor, iconFontColorOpacity),
  };

  const bgStyle = {
    marginTop: `${topMargin}px`,
    marginLeft: `${Number(horizontalOutterMargin || 0) - 12}px`,
    marginRight: `${Number(horizontalOutterMargin || 0) - 12}px`,
    backgroundImage: hasBackground === 'Y' ? `url(${bgImg.src})` : 'initial',
    backgroundSize: '100%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };

  const innerStyle = {
    paddingLeft: `${Number(horizontalInnerPadding || 0)}px`,
    paddingRight: `${Number(horizontalInnerPadding || 0)}px`,
  };

  const renderMenuItem = ({ link, iconName, src }) => (
    <Clickable
      className={styles.menuItem}
      // onClick={() => {
      //   (window as any).location.href = link;
      // }}
      onClick={() => openConfiguredLink(link || '')}
    >
      <img
        src={src}
        alt=""
        onError={e => {
          e.target.onerror = null;
        }}
      />
      {iconName && (
        <span className={styles.menuName} style={nameStyle}>
          {iconName}
        </span>
      )}
    </Clickable>
  );
  const renderMenuList = (num, pics) => (
    <div
      className={cl(styles.menuList, {
        [styles.tab8]: num === 8,
      })}
    >
      {(pics || []).map((item, index) => (
        <Fragment key={index}>{renderMenuItem(item)}</Fragment>
      ))}
    </div>
  );

  const renderMenus = (num, pics = []) => {
    const firstPage = pics.slice(0, num);
    const secondPage = pics.slice(num);
    const hasSecondSwiperItem = secondPage.length > 0;
    const swiperProps = hasSecondSwiperItem
      ? { style: { paddingBottom: '0.2rem' } }
      : { indicatorProps: { style: { display: 'none' } } };

    return (
      <Swiper {...swiperProps}>
        <Swiper.Item>{renderMenuList(num, firstPage)}</Swiper.Item>
        {hasSecondSwiperItem && <Swiper.Item>{renderMenuList(num, secondPage)}</Swiper.Item>}
      </Swiper>
    );
  };

  let num = 4;
  if (['noTab8', 'withTab8'].includes(menuStyle)) {
    num = 8;
  }
  return (
    <div
      className={cl(styles.carouselBox, {
        hidden: !visible,
      })}
      style={bgStyle}
    >
      <div className={styles.inner} />
      {['noTab4', 'noTab8'].includes(menuStyle) ? (
        <div className={styles.iconBox} style={innerStyle}>
          {renderMenus(num, sheet1Pictures)}
        </div>
      ) : (
        <div className={styles.iconBox} style={innerStyle}>
          <Tabs activeKey={activeTabKey} centered>
            <Tabs.TabPane tab={<div style={tab1ColorStyles}>{sheet1}</div>} key="SHEET1">
              {renderMenus(num, sheet1Pictures)}
            </Tabs.TabPane>
            <Tabs.TabPane tab={<div style={tab2ColorStyles}>{sheet2}</div>} key="SHEET2">
              {renderMenus(num, sheet2Pictures)}
            </Tabs.TabPane>
          </Tabs>
        </div>
      )}
    </div>
  );
}

export default QuickAccess;
